import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getVacancyGroupAPI from '../../api/get-vacancy-group';
import { getGroupsVacansyReceive, getGroupsVacansyReject, getGroupsVacansyRequested } from '../actions/admin-page';

interface IGetDivisionGroupsAction {
  type: string;
  payload: {
    name: string
  }
}

interface IGroupsVacansyResponse {
  group: {
    id: '',
    title: string,
    description: string,
    order: number,
    division: string
  }[]
}

const getGroupsVacansy = function* getGroupsVacansy(action: IGetDivisionGroupsAction) {
  try {
    const response: IGroupsVacansyResponse = yield call(getVacancyGroupAPI, action.payload.name, '');
    yield put(getGroupsVacansyReceive({ group: response }));
  } catch (error) {
    yield put(getGroupsVacansyReject({ error }));
  }
};

export default function* getGroupsVacansyWatcher() {
  yield takeLatest(getGroupsVacansyRequested, getGroupsVacansy);
}
